export default [
	{
		path: '/pro-users-list',
		name: 'ProUserList',
		component: require('../pages/proUsers/proUser.list.vue').default,
		meta: {
			navigationTitle: 'proUser',
			navigationSubTitle: 'list',
		},
	},
	{
		path: '/bot-users-list',
		name: 'botUserList',
		component: require('../pages/users/botUser.list.vue').default,
		meta: {
			navigationTitle: 'botUser',
			navigationSubTitle: 'list',
		},
	},
	{
		path: '/pro-users-group',
		name: 'AddProUser',
		component: require('../pages/proUsers/proUser.add.vue').default,
		meta: {
			navigationTitle: 'proUser',
			navigationSubTitle: 'add',
		},
	},
	{
		path: '/pro-users/:id',
		name: 'ProUserDetail',
		component: require('../pages/proUsers/proUser.detail.vue').default,
		meta: {
			navigationTitle: 'proUser',
		},
	},
	{
		path: '/default-parameters',
		name: 'DefaultParametersList',
		component: require('../pages/defaultParameters/defaultParameters.list.vue').default,
		meta: {
			navigationTitle: 'defaultParameter',
			navigationSubTitle: 'list',
		},
	},
	{
		path: '/add-default-parameters',
		name: 'AddDefaultParameters',
		component: require('../pages/defaultParameters/defaultParameters.add.vue').default,
		meta: {
			navigationTitle: 'defaultParameter',
			navigationSubTitle: 'add',
		},
	},
	{
		path: '/default-parameters/:id',
		name: 'DefaultParametersDetail',
		component: require('../pages/defaultParameters/defaultParameters.detail.vue').default,
		meta: {
			navigationTitle: 'defaultParameter',
		},
	},
	{
		path: '/bot-groups',
		name: 'BotGroupsList',
		component: require('../pages/botGroups/botGroups.list.vue').default,
		meta: {
			navigationTitle: 'botGroups',
			navigationSubTitle: 'list',
		},
	},
	{
		path: '/add-bot-groups',
		name: 'AddBotGroups',
		component: require('../pages/botGroups/botGroups.add.vue').default,
		meta: {
			navigationTitle: 'botGroups',
			navigationSubTitle: 'add',
		},
	},
	{
		path: '/bot-groups/:id',
		name: 'BotGroupsDetail',
		component: require('../pages/botGroups/botGroups.detail.vue').default,
		meta: {
			navigationTitle: 'botGroups',
		},
	},
]



// WEBPACK FOOTER //
// ./src/router/proUsers.js